import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { HYDRATE } from "next-redux-wrapper";
import { IUserInfo } from "@/props/IUser";

interface UserState {
  token?: string;
  userInfo?: IUserInfo;
}

const initialState: UserState = {
  token: undefined,
  userInfo: undefined,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string | undefined>) => {
      state.token = action.payload;
    },
    setUserInfo: (state, action: PayloadAction<IUserInfo | undefined>) => {
      state.userInfo = action.payload;
    },
    logout: (state) => {
      state.token = undefined;
      state.userInfo = undefined;
    },
  },
  extraReducers: {
    [HYDRATE]: (state, action) => {
      return {
        ...state,
        ...action.payload.user,
      };
    },
  },
});

export const { setToken, setUserInfo, logout } = userSlice.actions;
export default userSlice.reducer;
